(() => {
  const root = document.querySelector("[data-acc-root]");
  if (!root) return;

  const pageType = root.dataset.page; // "landing" or "family"
  const S3_BASE = (root.dataset.s3Base || "").replace(/\/$/, "");
  if (!S3_BASE) {
    console.warn("Missing data-s3-base on [data-acc-root]");
    return;
  }

  const qs = new URLSearchParams(window.location.search);
  const familyId = qs.get("familyId");

  const fetchJson = async (url) => {
    const r = await fetch(url, { cache: "no-store" });
    if (!r.ok) throw new Error(`HTTP ${r.status} for ${url}`);
    return await r.json();
  };

  const setText = (el, txt) => { if (el) el.textContent = txt ?? ""; };

  const buildFamilyHref = (fam) => `/pages/oem-accessories-family?familyId=${encodeURIComponent(fam.id)}`;

  // ---------- LANDING ----------
  const renderLanding = async () => {
    const grid = document.getElementById("acc-family-grid");
    const tpl = document.getElementById("acc-family-tile");
    if (!grid || !tpl) return;

    const index = await fetchJson(`${S3_BASE}/families_index.json`);
    const families = (index.families || []).slice().sort((a, b) => (a.order ?? 9999) - (b.order ?? 9999));

    grid.innerHTML = "";
    for (const fam of families) {
      const node = tpl.content.firstElementChild.cloneNode(true);
      node.href = buildFamilyHref(fam);

      const img = node.querySelector("img");
      const title = node.querySelector(".acc__tileTitle");
      const meta = node.querySelector(".acc__tileMeta");

      setText(title, fam.description);
      setText(meta, `${fam.count ?? 0} accessories`);

      if (img) {
        if (fam.imageUrl) {
          img.src = fam.imageUrl;
          img.alt = fam.description || "Family";
        } else {
          // simple placeholder (transparent GIF)
          img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACw=";
          img.alt = fam.description || "Family";
        }
      }

      grid.appendChild(node);
    }
  };

  // ---------- FAMILY PAGE ----------
  const elTitle = document.getElementById("acc-family-title");
  const elSuper = document.getElementById("acc-supermodel");
  const elModel = document.getElementById("acc-model");
  const elYear  = document.getElementById("acc-year");
  const elCards = document.getElementById("acc-cards");
  const elCount = document.getElementById("acc-count");
  const cardTpl = document.getElementById("acc-card");

  const setSelectOptions = (select, options, placeholder = "All") => {
    select.innerHTML = "";
    const opt0 = document.createElement("option");
    opt0.value = "";
    opt0.textContent = placeholder;
    select.appendChild(opt0);

    for (const v of options) {
      const o = document.createElement("option");
      o.value = v;
      o.textContent = v;
      select.appendChild(o);
    }
  };

  const uniqueSorted = (arr) => Array.from(new Set(arr.filter(Boolean))).sort((a,b) => a.localeCompare(b));

const renderCards = (cards, familyName) => {
  if (!elCards || !cardTpl) return;
  elCards.innerHTML = "";

  // DEDUPE: prefer SKU, fallback to code
  const map = new Map();
  for (const c of (cards || [])) {
    const key = (c.sku ? String(c.sku).trim() : "") || (c.code ? String(c.code).trim() : "");
    if (!key) continue;
    if (!map.has(key)) map.set(key, c);
  }
  const list = Array.from(map.values());

  setText(elCount, `${list.length} result${list.length === 1 ? "" : "s"}`);

  for (const c of list) {
    const li = cardTpl.content.firstElementChild.cloneNode(true);

    const linkEl = li.querySelector(".acc__cardLink");
    const imgEl = li.querySelector(".acc__cardImg");
    const titleEl = li.querySelector(".acc__cardTitle");
    const badgesEl = li.querySelector(".acc__cardBadges");

    // Build product URL (handle == sku)
    const sku = c.sku ? String(c.sku).trim() : "";
    const href = c.productUrl || (sku ? `/products/${sku.toLowerCase()}` : "#");

    if (linkEl) linkEl.href = href;

    if (titleEl) titleEl.textContent = c.name || c.code || "Accessory";

    if (imgEl) {
      if (c.image) {
        imgEl.src = c.image;
      } else {
        imgEl.removeAttribute("src"); // avoids broken-image icon
      }
      imgEl.alt = c.name || c.code || familyName || "Accessory";
    }

    if (badgesEl) {
      badgesEl.innerHTML = "";
      if (String(c.lastChance || "") === "1") {
        const b = document.createElement("span");
        b.className = "acc__badge acc__badge--last";
        b.textContent = "Last chance";
        badgesEl.appendChild(b);
      }
    }

    elCards.appendChild(li);
  }
};


  const renderFamily = async () => {
    if (!familyId) {
      setText(elTitle, "Accessories");
      if (elCards) elCards.innerHTML = `<p>Select a family first: <a href="/pages/oem-accessories">Go to accessories landing</a></p>`;
      return;
    }

    const index = await fetchJson(`${S3_BASE}/families_index.json`);
    const fam = (index.families || []).find(f => String(f.id) === String(familyId));
    if (!fam) {
      setText(elTitle, "Accessories");
      if (elCards) elCards.innerHTML = `<p>Family not found. <a href="/pages/oem-accessories">Go back</a></p>`;
      return;
    }

    setText(elTitle, `${fam.description} OEM Accessories`);

    // Load family-specific JSON
    const fitment = await fetchJson(`${S3_BASE}/${fam.fitmentFile}`);
    const list    = await fetchJson(`${S3_BASE}/${fam.listFile}`);

    const tree = fitment.superModels || {};
    const allCards = (list.accessories || []);

    // Build supermodel options
    const superModels = uniqueSorted(Object.keys(tree));
    setSelectOptions(elSuper, superModels, "All supermodels");

    // State
    let selSuper = "";
    let selModel = "";
    let selYear  = "";

    const updateModelOptions = () => {
      const models = selSuper && tree[selSuper] ? Object.keys(tree[selSuper]) : [];
      setSelectOptions(elModel, uniqueSorted(models), "All models");
      elModel.disabled = !selSuper || models.length === 0;
      selModel = "";
      updateYearOptions();
    };

    const updateYearOptions = () => {
      const years =
        selSuper && selModel && tree[selSuper] && tree[selSuper][selModel]
          ? Object.keys(tree[selSuper][selModel])
          : [];
      setSelectOptions(elYear, uniqueSorted(years), "All years");
      elYear.disabled = !(selSuper && selModel) || years.length === 0;
      selYear = "";
      updateResults();
    };

    const updateResults = () => {
      // If no fitment filters, show entire family list (flat list)
      if (!selSuper) {
        renderCards(allCards, fam.description);
        return;
      }

      // If only supermodel, union all models/years under it
      if (selSuper && !selModel) {
        const bucket = tree[selSuper] || {};
        const map = new Map();
        for (const m of Object.keys(bucket)) {
          for (const y of Object.keys(bucket[m] || {})) {
            for (const c of (bucket[m][y] || [])) {
              map.set(c.code, c);
            }
          }
        }
        renderCards(Array.from(map.values()), fam.description);
        return;
      }

      // If supermodel+model but no year, union all years under that model
      if (selSuper && selModel && !selYear) {
        const bucket = (tree[selSuper] || {})[selModel] || {};
        const map = new Map();
        for (const y of Object.keys(bucket)) {
          for (const c of (bucket[y] || [])) {
            map.set(c.code, c);
          }
        }
        renderCards(Array.from(map.values()), fam.description);
        return;
      }

      // Exact match
      const exact = (((tree[selSuper] || {})[selModel] || {})[selYear]) || [];
      renderCards(exact, fam.description);
    };

    // Wire selects
    elSuper.addEventListener("change", () => {
      selSuper = elSuper.value;
      updateModelOptions();
      updateResults();
    });

    elModel.addEventListener("change", () => {
      selModel = elModel.value;
      updateYearOptions();
      updateResults();
    });

    elYear.addEventListener("change", () => {
      selYear = elYear.value;
      updateResults();
    });

    // Initial render
    renderCards(allCards, fam.description);
  };

  // Boot
  (async () => {
    try {
      if (pageType === "landing") await renderLanding();
      if (pageType === "family") await renderFamily();
    } catch (e) {
      console.error(e);
      const msg = `<p>Sorry—couldn’t load accessories data. Check your S3 base URL.</p>`;
      if (pageType === "landing") {
        const grid = document.getElementById("acc-family-grid");
        if (grid) grid.innerHTML = msg;
      } else {
        if (elCards) elCards.innerHTML = msg;
      }
    }
  })();
})();
